// extracted by mini-css-extract-plugin
export default {"main":"BaseSimpleItemEditorHeader_main__FUpzr"};